/**
 * O trecho encontrado pela busca, destacado no próprio valor da linha (RN-PAC-11). A comparação é
 * a da API: sem acento e sem caixa nos textos; só pelos dígitos em CPF e telefone, de modo que
 * "529982" encontra "529.982.247-25".
 */

const fold = (char: string) =>
  char
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

/** Onde o trecho está no texto exibido: início e fim, ou `null` quando não aparece. */
function findSnippet(text: string, snippet: string, digitsOnly: boolean): [number, number] | null {
  const keep = (char: string) => !digitsOnly || /\d/.test(char)
  // Cada caractere comparado lembra de qual posição do texto exibido ele veio.
  let folded = ''
  const origin: { start: number; end: number }[] = []
  let offset = 0
  for (const char of text) {
    for (const piece of fold(char)) {
      if (!keep(piece)) continue
      folded += piece
      origin.push({ start: offset, end: offset + char.length })
    }
    offset += char.length
  }
  const needle = Array.from(snippet)
    .flatMap((char) => Array.from(fold(char)))
    .filter(keep)
    .join('')
  if (needle === '') return null
  const index = folded.indexOf(needle)
  if (index === -1) return null
  return [origin[index]!.start, origin[index + needle.length - 1]!.end]
}

export function Highlighted({
  text,
  snippet,
  digitsOnly = false,
}: {
  text: string
  /** O trecho que a API encontrou; sem ele, o texto sai como está. */
  snippet?: string
  /** CPF e telefone: a comparação ignora a pontuação da máscara. */
  digitsOnly?: boolean
}) {
  const range = snippet ? findSnippet(text, snippet, digitsOnly) : null
  if (!range) return <>{text}</>
  const [start, end] = range
  return (
    <>
      {text.slice(0, start)}
      <mark className="text-ink bg-transparent underline underline-offset-2">
        {text.slice(start, end)}
      </mark>
      {text.slice(end)}
    </>
  )
}
